import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Container, Col, Row, Alert } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import Axios from 'axios';
import ReactHtmlParser from 'react-html-parser';

// Local Deps
import { RestURL } from '../../../config/properties';

import './Home.scss';
import manOnTabletImg from '../../../images/man.jpg';
import foundryImg from '../../../images/foundry1_min.jpg';
import msgs from '../../../config/messages';
import { toolingLocationListRoute } from '../../../config/navigation/routes';
// Components
import TopNav from '../../../components/TopNav';
// import IconFooter from '../../../components/IconFooter';

class Home extends React.Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    originalOrgId: PropTypes.string,
    orgInfo: PropTypes.object,
    newMessage: PropTypes.bool.isRequired,
    newMessageCount: PropTypes.number.isRequired,
    canSeeMessageCenter: PropTypes.bool,
    alertMessages: PropTypes.instanceOf(Array)
  };

  static defaultProps = {
    originalOrgId: null,
    orgInfo: null,
    canSeeMessageCenter: false,
    alertMessages: [],
  };
  constructor() {
    super();
    this.state = {
      banner: '',
    };
  }
  async componentWillMount() {
    try {
      const res = await Axios.get(`${RestURL}rest/api/banner`);
      const text = res.data;
      this.setState({
        banner: text.replace(/^'|'$/g, ''),
      });
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    const {
      login,
      logout,
      auth,
      originalOrgId,
      orgInfo,
      newMessage,
      newMessageCount,
      canSeeMessageCenter,
      alertMessages,
    } = this.props;
    if (auth.role && auth.role.toUpperCase().includes('GOVERNMENT')) {
      return <Redirect to={toolingLocationListRoute} />;
    }
    return (
      <div className="nf-home">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Home Page</title>
        </Helmet>
        {/* <!-- FIRST SECTION --> */}
        <section
          className="nf-home__section--landing"
          style={{ backgroundImage: `url(${foundryImg})` }}
        >
          <div className="nf-home__bg-layer">
            {/* <!-- TOP NAV --> */}
            <TopNav
              {...{
                login,
                logout,
                auth,
                originalOrgId,
                orgInfo,
                newMessage,
                newMessageCount,
                canSeeMessageCenter,
              }}
            />

            {/* <!-- CONTENT --> */}
            <Container>
              <Row>
                <Col sm={{ size: 10, offset: 1 }}>
                  {alertMessages[0]
                    ? alertMessages.map(message => (
                      <Alert color={message.alertType}>
                        {message.alertMessage}
                      </Alert>
                    ))
                    : null}
                  <div className="nf-home__section-content text-center">
                    <h1 className="nf-home__header">
                      {msgs.HomePage.mainHeader}
                    </h1>
                    <p className="nf-home__subheader">
                      {msgs.HomePage.subHeader}
                    </p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <div className="nf-home__section-banner">
                    {' '}
                    {ReactHtmlParser(this.state.banner)}
                  </div>
                </Col>
              </Row>
            </Container>

            {/* <!-- FLOATING DOWN ARROW --> */}
            <div className="nf-home__down-arrow nf-animation--floating-arrow">
              <span>
                <i className="fa fa-angle-down" />
              </span>
            </div>
          </div>
        </section>

        {/* <!-- SECOND SECTION --> */}
        <section className="nf-home__section nf-home__section--padding">
          <Container>
            <Row>
              <Col xs={12} md={4}>
                <div className="nf-home__info-block">
                  <div className="nf-home__info-icon">
                    <i className="icon-briefcase" />
                  </div>
                  <div className="nf-home__info-content">
                    <h5>{msgs.HomePage.info1.header}</h5>
                    <p>{msgs.HomePage.info1.text}</p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={4}>
                <div className="nf-home__info-block">
                  <div className="nf-home__info-icon">
                    <i className="icon-layers" />
                  </div>
                  <div className="nf-home__info-content">
                    <h5>{msgs.HomePage.info2.header}</h5>
                    <p>{msgs.HomePage.info2.text}</p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={4}>
                <div className="nf-home__info-block">
                  <div className="nf-home__info-icon">
                    <i className="icon-tools" />
                  </div>
                  <div className="nf-home__info-content">
                    <h5>{msgs.HomePage.info3.header}</h5>
                    <p>{msgs.HomePage.info3.text}</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* <!-- THIRD SECTION --> */}
        <section className="nf-home__section nf-home__section--split nf-home__section--gray">
          <Row>
            <Col md={12} lg={7}>
              <div
                className="nf-home__section-img"
                style={{ backgroundImage: `url(${manOnTabletImg})` }}
              />
            </Col>
            <Col md={12} lg={5}>
              <div className="nf-home__section-content">
                <div className="nf-home__info-block">
                  <div className="nf-home__info-icon">
                    <i className="icon-laptop" />
                    <i className="icon-desktop" />
                    <i className="icon-tablet" />
                  </div>
                  <div className="nf-home__info-content">
                    <h5>{msgs.HomePage.info4.header}</h5>
                    <p>{msgs.HomePage.info4.text}</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </section>

        {/* <!-- FOURTH SECTION --> */}
        <section className="nf-home__section nf-home__section--padding">
          <Container>
            <Row>
              <Col xs={12}>
                <div className="nf-home__section-content nf-home__section-content--quote text-center">
                  {msgs.HomePage.quote}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* <IconFooter /> */}
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/static/Home/Home.jsx